import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Emblem from "./Emblem";

/**
 * Full-bleed cinematic loader. Rainbow curtain wipe + PAINTKING wordmark
 * reveal, then unmounts on-load moment leading into the Hero reveal.
 */
export default function Curtain() {
    const [show, setShow] = useState(true);

    useEffect(() => {
        const t = setTimeout(() => setShow(false), 1600);
        return () => clearTimeout(t);
    }, []);

    return (
        <AnimatePresence>
            {show && (
                <motion.div
                    data-testid="page-curtain"
                    initial={{ y: 0 }}
                    exit={{ y: "-100%" }}
                    transition={{
                        duration: 0.9,
                        ease: [0.85, 0, 0.15, 1],
                    }}
                    className="fixed inset-0 z-[100] bg-black flex items-center justify-center overflow-hidden"
                >
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.4 }}
                        className="flex flex-col items-center gap-6"
                    >
                        <Emblem size={72} />
                        <div className="overflow-hidden">
                            <motion.div
                                initial={{ y: "110%" }}
                                animate={{ y: 0 }}
                                transition={{
                                    delay: 0.15,
                                    duration: 0.9,
                                    ease: [0.19, 1, 0.22, 1],
                                }}
                                className="font-display uppercase text-4xl md:text-6xl tracking-tight"
                            >
                                <span className="rainbow-text">PaintKing</span>
                            </motion.div>
                        </div>
                        <div className="overflow-hidden">
                            <motion.div
                                initial={{ y: "110%" }}
                                animate={{ y: 0 }}
                                transition={{
                                    delay: 0.35,
                                    duration: 0.7,
                                    ease: [0.19, 1, 0.22, 1],
                                }}
                                className="font-mono text-[10px] tracking-[0.4em] uppercase text-white/60"
                            >
                                Loading the rolling palette…
                            </motion.div>
                        </div>
                    </motion.div>

                    {/* Rainbow bar sweep */}
                    <motion.div
                        initial={{ scaleX: 0, transformOrigin: "left" }}
                        animate={{ scaleX: 1 }}
                        transition={{ delay: 0.4, duration: 1, ease: [0.85, 0, 0.15, 1] }}
                        className="absolute bottom-0 left-0 right-0 h-1.5 rainbow-bg"
                    />
                </motion.div>
            )}
        </AnimatePresence>
    );
}
